(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-faq-editorial"] && !Shopify.designMode) return;
  try {
    
function initializeFBFaq(scope){
  scope.querySelectorAll('.fb-faq').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const links=[...root.querySelectorAll('[data-faq-category]')];
    const panels=[...root.querySelectorAll('[data-faq-panel]')];
    function select(id){panels.forEach(panel=>{panel.hidden=panel.dataset.faqPanel!==id;});links.forEach(link=>{if(link.dataset.faqCategory===id)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});}
    links.forEach(link=>link.addEventListener('click',event=>{event.preventDefault();select(link.dataset.faqCategory);}));
    if(links.length){const target=links.find(link=>link.hash===location.hash)||links[0];select(target.dataset.faqCategory);}
    root.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-faq-panel]');if(panel){select(panel.dataset.faqPanel);const detail=event.target.closest('details');if(detail)detail.open=true;}});
  });
}
initializeFBFaq(document);
document.addEventListener('shopify:section:load',()=>initializeFBFaq(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-home-paths"] && !Shopify.designMode) return;
  try {
    
function fbConcernInit(){document.querySelectorAll('.fb-home .concerns').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.concern-grid');const prev=root.querySelector('[data-concern-prev]');const next=root.querySelector('[data-concern-next]');if(!track||!prev||!next)return;function update(){prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2}function move(dir){track.scrollBy({left:dir*(track.querySelector('.concern-tile').getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update()})}fbConcernInit();document.addEventListener('shopify:section:load',fbConcernInit);

  } catch(e) { console.error(e); }
})();
})();
